<template lang="pug">
RomatchDialog(:show="show")
  template(v-slot:body)
    p {{ message }}
  template(v-slot:footer)
    .modal-buttons
      RomatchButton(@click="$emit('hide')") OK
</template>

<script>
export default {
  name: 'RomatchModal',
  props: {
    show: Boolean,
    message: String,
  },
}
</script>

<style scoped lang="stylus">
.modal-buttons
  margin-top 2rem

  button
    width 7rem
    margin 0 1rem
</style>
